import { createSelector } from '@ngrx/store';
import {
  PayRatesFeatureModel,
  PayRatesFeatureState,
  PayRatesTouchlessFeatureModel,
} from '../interfaces/shared.interface';
import { PayRatesTouchlessHttpModel } from '../../http/dashboard/dashboard-http.models';
import { selectFeatureStore } from './generic.selectors';

export const selectPayRates = createSelector(
  selectFeatureStore,
  ({ payRates }): PayRatesFeatureModel => payRates,
);

export const selectTouchlessPayRates = createSelector(
  selectFeatureStore,
  ({ payRates }): PayRatesTouchlessFeatureModel => payRates,
);

export const selectMinMaxPayRates = createSelector<
  object,
  PayRatesFeatureState,
  Pick<PayRatesTouchlessHttpModel, 'minRate' | 'maxRate'>
>(selectPayRates, ({ minRate, maxRate }) => ({
  minRate,
  maxRate,
}));
